module.exports = __webpack_public_path__ + "static/img/livre.a748e792.png";